/* ============================================================
   KaNi Candy - Liefertag und Restzeit
   Markup: Baustein "Lieferung & Bestand" in sections/main-product.liquid.

   Warum im Browser und nicht in Liquid: Shopify legt die gerenderte Seite
   in den Zwischenspeicher. Ein in Liquid gerechnetes Datum stuende am
   naechsten Tag falsch da - und eine falsche Lieferzusage ist schlimmer
   als gar keine. Ohne JavaScript bleibt die Zeile deshalb einfach weg.

   Gerechnet wird in deutscher Zeit, nicht in der des Besuchers: der
   Annahmeschluss gilt im Lager, nicht am Urlaubsort.
   ============================================================ */
(function () {
  'use strict';

  var WOCHENTAG = new Intl.DateTimeFormat('de-DE', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
  });

  /* Heute in Deutschland, zerlegt. Intl ist der einzige Weg, der die
     Sommerzeit nicht von Hand nachbauen muss. */
  function jetztHier() {
    var teile = new Intl.DateTimeFormat('de-DE', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date());
    var p = {};
    for (var i = 0; i < teile.length; i++) p[teile[i].type] = teile[i].value;
    return {
      tag: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
      sekunden: (+p.hour % 24) * 3600 + +p.minute * 60 + +p.second
    };
  }

  function istWerktag(d, samstag) {
    var w = d.getUTCDay();
    if (w === 0) return false;
    if (w === 6) return samstag;
    return true;
  }

  function naechsterWerktag(d, samstag) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!istWerktag(n, samstag));
    return n;
  }

  /* "15 Std. 49 Min." - unter einer Stunde nur die Minuten. */
  function restText(sekunden) {
    var min = Math.floor(sekunden / 60);
    var std = Math.floor(min / 60);
    min = min % 60;
    if (std > 0) return std + ' Std. ' + min + ' Min.';
    return min + ' Min.';
  }

  class KaniLieferzeit extends HTMLElement {
    connectedCallback() {
      this.zeile = this.querySelector('[data-kani-lief-zeile]');
      this.text = this.querySelector('[data-kani-lief-text]');
      if (!this.zeile || !this.text) return;

      this.tage = parseInt(this.dataset.tage, 10) || 0;
      this.samstag = this.dataset.samstag === '1';

      var schluss = String(this.dataset.schluss || '').split(':');
      var std = parseInt(schluss[0], 10);
      var min = parseInt(schluss[1], 10);
      /* Unbrauchbare Eingabe im Theme-Editor: lieber ohne Restzeit rechnen
         als mit einer erfundenen Uhrzeit. */
      this.schluss = (std >= 0 && std <= 23 && min >= 0 && min <= 59)
        ? std * 3600 + min * 60
        : null;

      if (this.tage < 1) return;

      this.zeichnen();
      this.uhr = setInterval(this.zeichnen.bind(this), 20000);
    }

    disconnectedCallback() {
      if (this.uhr) clearInterval(this.uhr);
    }

    zeichnen() {
      var jetzt = jetztHier();
      var rest = this.schluss === null ? -1 : this.schluss - jetzt.sekunden;

      /* Versandtag: heute, solange heute ein Werktag ist und der Schluss
         noch nicht durch ist. Sonst der naechste Werktag. */
      var heuteWerktag = istWerktag(jetzt.tag, this.samstag);
      var ab = jetzt.tag;
      if (rest <= 0 || !heuteWerktag) {
        ab = naechsterWerktag(ab, this.samstag);
      }
      for (var i = 0; i < this.tage; i++) ab = naechsterWerktag(ab, this.samstag);

      /* Die Restzeit steht nur da, wenn sie auch etwas aendert. Am Sonntag
         geht so oder so nichts raus - ein Countdown waere dort eine
         Dringlichkeit, die es gar nicht gibt. */
      var satz = 'Lieferung bis <strong>' + WOCHENTAG.format(ab) + '</strong>';
      if (heuteWerktag && rest > 60) satz += ' – bestelle innerhalb ' + restText(rest);

      this.text.innerHTML = satz;
      this.zeile.hidden = false;
    }
  }

  if (!customElements.get('kani-lieferzeit')) {
    customElements.define('kani-lieferzeit', KaniLieferzeit);
  }
})();
